<template>
  <div
    class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid"
  >
    <!-- end of row -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <b-tabs>
              <b-tab :title="$t('users.users')" active>
                <div
                  class="tab-pane"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <b-table :stacked="($mobile==1)" 
                        ref="table"
                        class="vuetable"
                        sort-by="id"
                        sort-desc.sync="false"
                        :current-page="currentPage"
                        :fields="bootstrapTable.fields"
                        :items="dataProvider"
                      >
                        <template #cell(account_type)="data">
                          <b-badge
                            variant="success"
                            class="badge-glow"
                            v-if="data.item.account_type == 'student'"
                          >
                            {{ data.item.account_type }}
                          </b-badge>
                          <b-badge
                            variant="success"
                            class="badge-glow"
                            v-if="data.item.account_type == 'teacher'"
                          >
                            {{ data.item.account_type }}
                          </b-badge>
                        </template>
                        <template #cell(code)="data">
                          <b-link
                            :to="{
                              name: 'profile',
                              params: { id: data.item.id },
                            }"
                          >
                            {{ data.item.code }}</b-link
                          >
                        </template>
                        <div
                          v-if="load"
                          class="lds-ripple-bk justify-content-center"
                        >
                          <div></div>
                          <div></div>
                        </div>

                        <hr />
                        <b-pagination
                          align="right"
                          class="
                            dataTables_paginate
                            paging_simple_numbers
                            pagination-warning
                          "
                          :total-rows="totalRows"
                          :per-page="perPage"
                          v-model="currentPage"
                        >
                          <template v-slot:next-text>
                            <i class="fas fa-angle-left" />
                          </template>
                          <template v-slot:prev-text>
                            <i class="fas fa-angle-right" />
                          </template>
                          <template v-slot:first-text>
                            <i class="fas fa-step-forward" />
                          </template>
                          <template v-slot:last-text>
                            <i class="fas fa-step-backward" />
                          </template>
                        </b-pagination>
                      </b-table>
                      <!-- end of table -->
                    </div>
                    <!-- end of col -->
                  </div>
                  <!-- end of row -->
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <!-- end of card body -->
        </div>
        <!-- end of card -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
  </div>
</template>

<script>
import controller from "../../../Controllers/UsersController";
import config from "../../../config/config";
import Auth from "@/Apis/Auth";
export default {
  name: "UsersDataTable",
  props: ["items", "editItem"],
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "code",
            label: this.$i18n.t("students.academic_number"),
            sortable: true,
          },
          {
            key: "first_name",
            label: this.$i18n.t("students.first_name"),
            sortable: true,
          },
          {
            key: "last_name",
            label: this.$i18n.t("students.last_name"),
            sortable: true,
          },


          {
            key: "account_type",
            label:  this.$i18n.t("students.account_type"),
            sortable: true,
          },
        ],
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
    };
  },
  created() {
    if (Auth.USER.account_type == "teacher") {
      this.bootstrapTable.fields.splice(0, 0, {
        key: "code",
        label: this.$i18n.t("students.academic_number"),
        sortable: true,
      });
    }
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      let id = localStorage.getItem("eduProgram");
      this.load = true;
      this.params = ctx;
      const data = await new controller().eduProgramUsers(
        id,
        this.apiParamsConverter()
      );
      this.currentPage = 1;
      this.perPage = data.length;
      this.totalRows = data.length;
      this.from = 1;
      this.to = data.length;
      this.total = data.length;
      this.data = data;
      this.load = false;
      return data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      apiParams.type = this.$route.params.type;
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
  },
  created() {
    if (Auth.USER.account_type == "teachers")
      this.bootstrapTable.fields = [
        { key: "checkbox", label: "", sortable: false },
        {
          key: "code",
          label: "الرقم الأكاديمي",
          sortable: true,
        },
        {
          key: "first_name",
          label: "الاسم الأول",
          sortable: true,
        },
        {
          key: "last_name",
          label: "اسم العائلة",
          sortable: true,
        },

        {
          key: "account_type",
          label: "نوع الحساب",
          sortable: true,
        },
      ];
  },
};
</script>

